//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Query_fun, LookNews_fun, Update_fun } from '@/api/policymanagement';
import { getChilComList, getProductList, getCompanyList } from '@/api/baseDate';
export default {
  name: "claimquery",
  data: function data() {
    return {
      currentPage4: 4,
      loading: false,
      restaurants: [],
      timeout: null,
      tableData: [],
      options: [{
        value: "666666",
        label: "人民保险"
      }],
      options1: [{
        value: "1",
        label: "上海分公司"
      }],
      options2: [],
      options3: [{
        value: "1",
        label: "是"
      }],
      options4: [{
        value: "0",
        label: "新建"
      }, {
        value: "1",
        label: "待补录"
      }, {
        value: "2",
        label: "暂存"
      }, {
        value: "3",
        label: "自核失败"
      }, {
        value: "4",
        label: "自核通过提交核保"
      }, {
        value: "5",
        label: "核保失败"
      }, {
        value: "6",
        label: "核保成功"
      }, {
        value: "7",
        label: "已申报"
      }],
      inForm: {
        companyCode: "",
        customsListNo: "",
        // insuranceCompanyCode: this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '',
        insuranceCompanyCode: "",
        insuranceCompanyName: "",
        insuredName: "",
        policyNo: "",
        appliName: "",
        protocolNo: "",
        riskCode: "",
        riskName: "",
        startDateEnd: "",
        startDateStart: "",
        invoiceNo: ""
      },
      pageNo: 1,
      //第几页
      pageSize: 10,
      //每页数量
      total: 0,
      //总条数
      rules: {
        insuranceCompanyCode: [{
          required: true,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        companyCode: [{
          required: false,
          message: '请选择分支机构',
          trigger: 'change'
        }],
        riskCode: [{
          required: false,
          message: '请选择产品名称',
          trigger: 'change'
        }],
        addRecordFlag: [{
          required: false,
          message: '请选择自动申报补录',
          trigger: 'change'
        }],
        proposalStatus: [{
          required: false,
          message: '请选择保单状态',
          trigger: 'change'
        }]
      },
      options_insuranceCompanyName: [],
      options_companyName: []
    };
  },
  mounted: function mounted() {
    this.search_s('inForm');
    this.riskqueryAll_fun(this.inForm.insuranceCompanyCode);
  },
  created: function created() {
    var list = this.$store.state.user.userinfo.insuranceCompanyList || [];
    var companyCode = '';

    if (this.$store.state.user.userinfo.insuranceCompanyList.length !== 0) {
      companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    } // 不同角色用户登录进去保险公司数据源不同
    // 货运险注册用户：register insuranceCompanyList
    // 子账号被保险人用户：subAssured sainsuranceCompanyList
    // 货运险注册用户+子账号被保险人用户 两者合并


    var userRoleType = this.$store.state.user.userinfo.userRoleType;

    if (userRoleType !== null && userRoleType.includes('subAssured')) {
      var saList = this.$store.state.user.userinfo.sainsuranceCompanyList || [];
      var saCompanyCode = this.$store.state.user.userinfo.sainsuranceCompanyList[0].insuranceCompanyCode || '';

      if (userRoleType === 'subAssured') {
        list = saList;
        companyCode = saCompanyCode;
      } else {
        list = list.concat(saList).filter(function (item, index, array) {
          return array.indexOf(item) === index;
        });
      }
    }

    this.get_select(list, companyCode);
    this.restaurants = this.loadAll(); //默认第一个保险公司

    this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value || '';
    this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label || '';
    this.Init_get();
  },
  methods: {
    //初始化
    Init_get: function Init_get() {
      var _this = this;

      //去除查询条件前后空格
      if (this.inForm.policyNo !== null && this.inForm.policyNo !== undefined && this.inForm.policyNo !== '') {
        this.inForm.policyNo = this.inForm.policyNo.replace(/(^\s*)|(\s*$)/g, "");
      }

      if (this.inForm.protocolNo !== null && this.inForm.protocolNo !== undefined && this.inForm.protocolNo !== '') {
        this.inForm.protocolNo = this.inForm.protocolNo.replace(/(^\s*)|(\s*$)/g, "");
      }

      if (this.inForm.customsListNo !== null && this.inForm.customsListNo !== undefined && this.inForm.customsListNo !== '') {
        this.inForm.customsListNo = this.inForm.customsListNo.replace(/(^\s*)|(\s*$)/g, "");
      }

      var data = this.inForm;
      this.loading = true;
      data.pageNo = this.pageNo;
      data.pageSize = this.pageSize;
      Query_fun(data).then(function (res) {
        var orgCode = JSON.parse(sessionStorage.getItem('neworgCode'));
        console.log(orgCode, "信用代码");
        console.log(res.content);

        if (res.content != null) {
          for (var i = 0; i < res.content.length; i++) {
            // 如果查询数据的投保人不是当前登录用户-usertype==0，identifyNumber是投保人的orgcode
            // 场景1，查询的数据是投保数据：使用orgcode - identifyNumber，相同则usertype=1 ，不同则0
            // 场景2，查询的数据是被保险人数据：使用userId - createBy，相同则usertype=1 ，不同则0
            if (res.content[i].queryType != null) {
              var queryType = res.content[i].queryType;

              if (queryType === 'register') {
                if (res.content[i].identifyNumber != null) {
                  if (orgCode !== res.content[i].identifyNumber) {
                    console.log(res.content[i].identifyNumber, i);
                    res.content[i].user_type = '0';
                    _this.permissionsbtn = false;
                  } else {
                    res.content[i].user_type = '1';
                    _this.permissionsbtn = true;
                  }
                } else {
                  res.content[i].user_type = '0';
                  _this.permissionsbtn = false;
                }
              } else if (queryType === 'subAssured') {
                // 查出的数据都是自己为被保险人的数据，无需额外判断
                res.content[i].user_type = '1';
                _this.permissionsbtn = true;
              } else {
                res.content[i].user_type = '0';
                _this.permissionsbtn = false;
              }
            } else {
              res.content[i].user_type = '0';
              _this.permissionsbtn = false;
            }
          }
        }

        _this.tableData = res.content || [];
        _this.total = res.totalCount;
        _this.loading = false;
      });
    },
    //保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label;
      this.companyqueryAll_fun(val);
      this.riskqueryAll_fun(val);
    },
    //分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      this.inForm.companyName = obj.label;
    },
    //产品名称 --险种
    riskCode_ch: function riskCode_ch(val) {
      var obj = {};
      obj = this.options2.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据l
      });
      this.inForm.riskName = obj.label;
    },
    //每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    //当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    //查询
    search_s: function search_s(formName) {
      var _this2 = this;

      this.pageNo = 1;
      this.pageSize = 10;

      if (this.inForm.startDateEnd && this.inForm.startDateStart) {
        if (this.getTimes(this.inForm.startDateStart) > this.getTimes(this.inForm.startDateEnd)) {
          this.$message({
            message: '录入起保时间的起期不能晚于起保时间止期',
            type: 'warning'
          });
          return;
        }
      } else if (this.inForm.startDateEnd && !this.inForm.startDateStart) {
        this.$message({
          message: '请录入起保时间起期',
          type: 'warning'
        });
        return;
      } else if (!this.inForm.startDateEnd && this.inForm.startDateStart) {
        this.$message({
          message: '请录入起保时间止期',
          type: 'warning'
        });
        return;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.Init_get();
        } else {
          return false;
        }
      });
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      // console.log(this.ruleForm.businessStartDate)
      var date = time;
      date = date.substring(0, 19);
      date = date.replace(/-/g, '/'); //必须把日期'-'转为'/'

      var timestamp = new Date(date).getTime();
      return timestamp;
    },
    //重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        proposalNo: '',
        // insuranceCompanyCode: this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode,
        insuranceCompanyCode: '',
        insuranceCompanyName: '',
        companyCode: '',
        companyName: '',
        riskCode: '',
        riskName: '',
        startDate: '',
        endDate: '',
        insuredName: '',
        appliName: '',
        addRecordFlag: '',
        proposalStatus: '',
        protocolNo: '',
        customsListNo: ''
      };
      this.insuranceCompanyCode_ch(this.inForm.insuranceCompanyCode);
    },
    //删除
    del_but: function del_but(row) {
      var _this3 = this;

      var data = {
        proposalNo: row.row.proposalNo
      };
      deleteByProposalNo_fun(data).then(function (res) {
        if (res.rtnCode == "0000") {
          _this3.$message({
            message: '删除成功',
            type: 'success'
          });

          _this3.Init_get();
        }
      }); //				this.tableData.splice(row.$index, 1)
    },
    // 支持模糊查询
    loadAll: function loadAll() {
      return [{
        "value": "三全鲜食（北新泾店）",
        "address": "长宁区新渔路144号"
      }, {
        "value": "Hot honey 首尔炸鸡（仙霞路）",
        "address": "上海市长宁区淞虹路661号"
      }, {
        "value": "新旺角茶餐厅",
        "address": "上海市普陀区真北路988号创邑金沙谷6号楼113"
      }];
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {},
    //查看 ------ 编辑
    view_but: function view_but(type, row) {
      // this.$router.push({
      //   name: 'claimentry',
      //   params: {
      //     policyNo: row.row.policyNo,
      //     type: type,
      //     proposalNo:row.row.proposalNo
      //   }
      //
      // });
      // var params = {
      //   policyNo: row.row.policyNo,
      //   type: type,
      //   proposalNo: row.row.proposalNo
      // }
      // this.$router.push({
      //   path: `/claimapplication/claimentry/${params.policyNo}/${params.type}/${params.proposalNo}`
      // });
      var params = {
        policyNo: row.row.policyNo,
        type: type,
        proposalNo: row.row.proposalNo,
        flag: 'claim',
        claimCode: row.row.claimCode
      };
      this.$router.push({
        path: "/claimapplication/claimentry/".concat(params.policyNo, "/").concat(params.type, "/").concat(params.proposalNo, "/").concat(params.flag, "/").concat(params.claimCode)
      }); //				if(row.row.firstLogin == true) {
      //
      //				} else {
      //
      //					this.$message({
      //						message: '该保单号已经进行过理赔！',
      //						type: 'warning'
      //					});
      //
      //				}
    },
    view_but2: function view_but2(type, row) {
      var params = {
        type: type,
        insurancecompanyCode: row.row.insuranceCompanyCode,
        protocolNo: row.row.protocolNo,
        riskCode: row.row.riskCode,
        riskName: row.row.riskName,
        proposalNo: row.row.proposalNo
      }; // console.log(params.insurancecompanyCode)

      this.$router.push({
        path: "/policymanagement/insuranceentry/".concat(params.type, "/").concat(params.insurancecompanyCode, "/").concat(params.protocolNo, "/").concat(params.riskCode, "/").concat(params.riskName, "/").concat(params.proposalNo)
      });
    },
    //------下拉信息
    get_select: function get_select(list, code) {
      this.findInsuranceCompany_fun(list);
      this.companyqueryAll_fun(code); // cosole.log(list, 471)
    },
    //保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};

        if (list) {
          obj.value = list[i].insuranceCompanyCode || '';
          obj.label = list[i].insuranceCompanyName || '';
          this.options_insuranceCompanyName.push(obj);
        }
      } //				var data = {
      //					insuranceCompanyCode: code
      //				}
      //
      //				getCompanyList(data).then(res => {
      //
      //					this.options_insuranceCompanyName = []
      //					for(var i = 0; i < res.length; i++) {
      //						var obj = {}
      //						obj.value = res[i].insuranceCompanyCode
      //						obj.label = res[i].insuranceCompanyName
      //						this.options_insuranceCompanyName.push(obj)
      //					}
      //
      //				})

    },
    //分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this4 = this;

      var data = {
        insuranceCompanyCode: code || ''
      };
      getChilComList(data).then(function (res) {
        _this4.options_companyName = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this4.options_companyName.push(obj);
        }
      });
    },
    //产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this5 = this;

      var data = {
        insuranceCompanyCode: code || ''
      };
      getProductList(data).then(function (res) {
        _this5.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].riskCode;
          obj.label = res[i].riskName;

          _this5.options2.push(obj);
        }
      });
    }
  }
};